<template>
  <vs-dialog not-close prevent-close v-model="showDialog">
    <template #header>
      <h1 class="dialog-title">Welcome to <b>Open PO</b></h1>
    </template>

    <form @submit.prevent="signUp">
      <vs-input type="email" placeholder="Email" v-model="email">
        <template #icon>@</template>
      </vs-input>

      <vs-input type="password" placeholder="Password" v-model="password">
        <template #icon><i class="bx bxs-lock" /></template>
      </vs-input>

      <div class="dialog-level">
        <vs-checkbox>Remember me</vs-checkbox>
        <router-link to="/sign-in">Have an account?</router-link>
      </div>

      <vs-button block :loading="loading">Sign Up</vs-button>
    </form>
  </vs-dialog>
</template>

<script>
import supabase from '../supabase';

export default {
  name: 'SignUp',

  data() {
    return {
      email: '',
      password: '',
      showDialog: true,
      loading: false,
    };
  },

  methods: {
    async signUp() {
      try {
        this.loading = true;

        await supabase.auth.signup(
          this.email.toUpperCase(),
          this.password,
        );

        this.$router.push({ path: '/' });
      } catch (error) {
        this.loading = false;
        alert(JSON.parse(error.message).msg);
      }
    },
  },
};
</script>
